import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';
import { Link } from 'react-router-dom';
import { Loader2, BookOpenText } from 'lucide-react';

// A function to create a summary from content, handling HTML tags
const createSummary = (content) => {
  if (!content) return '';
  const strippedContent = content.replace(/<[^>]+>/g, '');
  if (strippedContent.length <= 150) return content;
  return strippedContent.substring(0, 150) + '...';
};

const ArticleCard = ({ article }) => {
  return (
    <div
      className="w-[280px] flex-shrink-0 snap-center bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
    >
      <div className="w-full h-44 overflow-hidden">
        <img
          src={article.imageUrl || "/articlesImages/articleImage1.jpg"}
          alt={article.title}
          className="w-full h-full object-cover"
          loading="lazy"
          fetchPriority="low"
        />
      </div>
      
      <div className="flex flex-col p-4 text-right">
        {/* Render article title as raw HTML */}
        <h3 
          className="text-lg font-bold text-gray-900 mb-2 line-clamp-2"
          dangerouslySetInnerHTML={{ __html: article.title }}
        />
        
        {/* Render article summary as raw HTML */}
        <p 
          className="text-gray-600 mb-4 text-sm line-clamp-3"
          dangerouslySetInnerHTML={{ __html: createSummary(article.content) }}
        />

        <Link 
          to={`/topic/${article.subjectId}/${article.id}`}
          className="inline-flex items-center justify-center py-2 px-4 bg-gray-800 text-white font-semibold rounded-lg hover:bg-gray-900 transition-all duration-300 mt-auto"
        >
          קרא עוד
        </Link>
      </div>
    </div>
  );
};

const AllArticlesSlider = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const articlesCollectionRef = collection(db, 'articles');
        const querySnapshot = await getDocs(articlesCollectionRef);
        const fetchedArticles = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setArticles(fetchedArticles);
      } catch (error) {
        console.error("Error fetching articles:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchArticles();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-48">
        <Loader2 className="w-12 h-12 text-amber-500 animate-spin" />
      </div>
    );
  }

  return (
    <div className="w-full py-16 bg-transparent" dir="rtl">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center mb-12">
          <BookOpenText className="w-8 h-8 text-amber-500 mb-2" />
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 mb-2">
            מאמרים מומלצים
          </h2>
          <p className="text-lg text-gray-600 max-w-lg">
            מגוון מאמרים מקצועיים שיעזרו לכם להבין את התהליך המשפטי.
          </p>
        </div>
        
        {articles.length > 0 ? (
          <div className="flex overflow-x-auto gap-6 pb-4 snap-x snap-mandatory hide-scrollbar">
            {articles.map(article => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-500 p-8">
            אין מאמרים זמינים כרגע.
          </div>
        )}
      </div>
    </div>
  );
};

export default AllArticlesSlider;
